module.exports = __webpack_public_path__ + "img/81.eab4f24f.jpg";